module.exports = __webpack_public_path__ + "img/friseMonParcours.fbc0c87e.svg";